import { useFormContext } from 'react-hook-form';

import type { ReviewPlatform } from '../constants';
import type { ReviewPrizepoolFormValues } from '../schemas';
import { useReviewPrizepoolStore } from '../services/store';

export const useHandleReviewSiteVisit = () => {
    const { setValue } = useFormContext<ReviewPrizepoolFormValues>();
    const markPlatformVisited = useReviewPrizepoolStore(state => state.markPlatformVisited);

    return (platform: ReviewPlatform) => {
        setValue(`${platform}Visited`, true);
        markPlatformVisited(platform);
    };
};
